import BoardProxy from '@/proxies/BoardProxy'
import Vuex from 'vuex'

export default {
    namespaced: true,
    actions: {
        boardMst({commit}, boardNo) {
            return new BoardProxy()
            .getBoardMstInfo( boardNo )
            .then(res => commit('boardMst',res.item))
        },
        qnaCnt({commit}, boardNo) {
            return new BoardProxy()
            .getBoardMstInfo( boardNo )
            .then(res => commit('qnaCnt',res.item.waitCnt))
        }


    },
    getters: {

    },
    mutations: {
        boardMst( state, boardMst ) {
            state.boardMst = {...boardMst}
            if(boardMst.boardNo == 1) { // q&a 대기 갯수
                state.waitCnt = boardMst.waitCnt
            }
        },
        qnaCnt( state, cnt ) {
            state.waitCnt = cnt
        }
    },
    state: {
        search: {

        },
        boardMst: {}
        ,
        waitCnt: 0
    }
}
